import icon from 'vue-svgicon';

icon.register({
    'regular/navigation-left': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M4.415 8.662A11.969 11.969 0 0 1 23.25 18.5a7.5 7.5 0 0 0-7.5-7.5 7.414 7.414 0 0 0-5.972 3.028l3.192 3.192a.75.75 0 0 1-.531 1.28H2.25A1.5 1.5 0 0 1 .75 17V6.808a.75.75 0 0 1 1.28-.531z" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
